<div class="sidenav-wrapper">

  <div class="logo-section" [class.collapsed-logo]="collapsed">
    <img [src]="collapsed ? 'assets/images/Just-logo.svg' : 'assets/images/BeExpert-logo (2).svg'" 
         class="auth-logo-img" 
         [alt]="collapsed ? 'Logo' : 'BeExpert Logo'" />

    <div class="circle-icon" (click)="toggleSidenav()">
      <mat-icon class="app-icon">
        {{ collapsed ? 'chevron_right' : 'chevron_left' }}
      </mat-icon>
    </div>
  </div>


  <div class="sidenav-content" [class.collapsed-content]="collapsed">
    <mat-nav-list class="me-2 ms-2">

      <ng-container *ngFor="let item of menuItems">

        <ng-container *ngIf="item.subItems && item.subItems.length > 0">
          <div class="submenu-wrapper">
            <a mat-list-item class="submenu-parent" (click)="toggleSubmenu(item)" [matTooltip]="item.label"
              [matTooltipDisabled]="!collapsed">

              <mat-icon class="folder-icon">{{item.icon}}</mat-icon>
              <span class="heading" *ngIf="!collapsed">{{item.label}}</span>

              <mat-icon class="arrow-icon" *ngIf="!collapsed" [class.open]="isExpanded(item)">
                expand_more
              </mat-icon>
            </a>

            <div class="submenu" *ngIf="isExpanded(item) && !collapsed">
              <ng-container *ngFor="let subItem of item.subItems">

                <a mat-list-item [routerLink]="subItem.route" [matTooltip]="subItem.label"
                  [matTooltipDisabled]="!collapsed" routerLinkActive="active-link"
                  [routerLinkActiveOptions]="{ exact: true }">
                  <mat-icon>{{subItem.icon}}</mat-icon>
                  <span class="heading">{{subItem.label}}</span>
                </a>
              </ng-container>
            </div>
          </div>
        </ng-container>


        <ng-container *ngIf="!item.subItems || item.subItems.length === 0">
          <a mat-list-item [routerLink]="item.route" [matTooltip]="item.label" [matTooltipDisabled]="!collapsed"
            routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }">
            <mat-icon>{{item.icon}}</mat-icon>
            <span class="heading" *ngIf="!collapsed">{{item.label}}</span>
          </a>
        </ng-container>

      </ng-container>

    </mat-nav-list>
  </div>


  <!-- FOOTER -->
  <div class="sidenav-footer" [class.collapsed-footer]="collapsed">
    <mat-divider></mat-divider>
    <mat-nav-list>
      <a mat-list-item (click)="logout()" matTooltip="Logout" [matTooltipDisabled]="!collapsed">
        <mat-icon class="logout-icon">logout</mat-icon>
        <span *ngIf="!collapsed" class="logout">Logout</span>
      </a>
    </mat-nav-list>
  </div>

</div>